'use client';
import { ComponentProps } from 'react';
import { SearchAlertToggle } from '../SearchAlertToggle/SearchAlertToggle';
import { SearchAlertTile } from './SearchAlertTile';

type Props = ComponentProps<typeof SearchAlertToggle>;

export const SearchAlertTileLowResults = (props: Props) => {
  return <SearchAlertTile {...props} inactiveVariant={'low-results'} />;
};
